import { OnInit, TemplateRef, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { Selectors } from 'store/root-reducer';
var CommentComponent = /** @class */ (function () {
    function CommentComponent(store, dialog, cdRef) {
        this.store = store;
        this.dialog = dialog;
        this.cdRef = cdRef;
        this.allowDeleteComment = false;
        this.submitNewComment = new EventEmitter();
        this.deleteComment = new EventEmitter();
        this.currentUser$ = this.store.select(Selectors.auth.getUser);
        this._commentList = [];
        this._loading = false;
    }
    Object.defineProperty(CommentComponent.prototype, "commentList", {
        get: function () {
            return this._commentList;
        },
        set: function (comments) {
            if (comments) {
                this._commentList = comments;
                this.cdRef.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommentComponent.prototype, "subHeaderName", {
        get: function () {
            return this._nameToShow;
        },
        set: function (name) {
            if (name) {
                this._nameToShow = name;
                this.cdRef.detectChanges();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommentComponent.prototype, "loading", {
        get: function () {
            return this._loading;
        },
        set: function (loading) {
            this._loading = loading;
            this.cdRef.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    CommentComponent.prototype.ngOnInit = function () {
    };
    /**
     * Adds form in modal window for adding comment
     * @method openAddCommentForm
     */
    CommentComponent.prototype.openAddCommentForm = function () {
        this.addCommentFormRef = this.dialog.open(this.addCommentForm, {
            width: '650px'
        });
    };
    /**
     * Closes modal for adding comment and clearing the text inside
     * @method closeAddCommentModal
     */
    CommentComponent.prototype.closeAddCommentModal = function () {
        this.commentContent = '';
        this.addCommentFormRef.close();
    };
    /**
     * Submit a new comment
     * @method submitComment
     */
    CommentComponent.prototype.emitSubmitComment = function () {
        this.submitNewComment.next(this.commentContent);
        this.closeAddCommentModal();
    };
    /**
     * Delete a comment
     * @method deleteComment
     */
    CommentComponent.prototype.emitDeleteComment = function (commentId) {
        this.deleteComment.next(commentId);
    };
    return CommentComponent;
}());
export { CommentComponent };
